/* unplugin-vue-components disabled */import script from "./page.vue?vue&type=script&setup=true&lang=ts"
export * from "./page.vue?vue&type=script&setup=true&lang=ts"

import "./page.vue?vue&type=style&index=0&id=10750f31&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/@best-shot+vue-loader@17.4.9_vue@3.5.29_typescript@5.9.3__webpack@5.105.4_patch_hash=5f_07b666b2ea009d68b3912e79e2f069a5/node_modules/@best-shot/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10750f31"]])

export default __exports__